import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdef9704&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fdef9704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef9704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdef9704')) {
      api.createRecord('fdef9704', component.options)
    } else {
      api.reload('fdef9704', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fdef9704&scoped=true&", function () {
      api.rerender('fdef9704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/builder/index.vue"
export default component.exports